import { FC, SVGProps } from "react";

const SearchIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" stroke="currentcolor" {...props}>
      <path d="M23.5 23.5L17.9839 17.9941M17.9839 17.9941C19.7878 16.1927 20.9038 13.7026 20.9038 10.9519C20.9038 5.45563 16.4482 1 10.9519 1C5.45563 1 1 5.45563 1 10.9519C1 16.4482 5.45563 20.9038 10.9519 20.9038C13.6975 20.9038 16.1834 19.792 17.9839 17.9941Z" />
    </svg>
  );
};

export default SearchIcon;
